class ProductBar extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event('change', { bubbles: true });
  }
  connectedCallback() {
    this.submitButton = this.querySelector('[name="add"]');
    this.productSelectors = Array.from(document.querySelector('product-selector')?.querySelectorAll('input[type="radio"], select') || []);
    this.scrollToFormButton = this.querySelector('[data-purchase-options-button]');
    this.inlineForm = document.querySelector('product-form');
    this.inlineButton = this.inlineForm?.querySelector('button[name="add"]');
    this.boundChange = event => this.onChange({name:event.target.dataset.name || event.target.name,value:event.target.value});
    this.boundVisibility = () => {
      if (this.visibilityFrame) return;
      this.visibilityFrame = requestAnimationFrame(() => { this.visibilityFrame=null; this.toggleVisibility(); });
    };
    this.boundScrollToForm = () => this.scrollToForm();
    this.addEventListener('change',this.boundChange);
    window.addEventListener('scroll',this.boundVisibility,{passive:true});
    window.addEventListener('resize',this.boundVisibility,{passive:true});
    window.addEventListener('load',this.boundVisibility);
    this.scrollToFormButton?.addEventListener('click',this.boundScrollToForm);
    this.prepareCompactPurchase();
    if (this.inlineButton) {
      this.visibilityObserver = new IntersectionObserver(this.boundVisibility,{threshold:[0,.1,1]});
      this.visibilityObserver.observe(this.inlineButton);
      this.formObserver = new MutationObserver(() => {this.syncCompactPurchase();this.boundVisibility();});
      this.formObserver.observe(this.inlineForm,{attributes:true,childList:true,subtree:true,characterData:true});
    }
    const price = document.querySelector('[id^="Product-Price-"]');
    if (price) {
      this.priceObserver = new MutationObserver(() => this.syncCompactPrice());
      this.priceObserver.observe(price,{childList:true,subtree:true,characterData:true});
    }
    this.toggleVisibility();
  }
  disconnectedCallback() {
    this.removeEventListener('change',this.boundChange);
    window.removeEventListener('scroll',this.boundVisibility);
    window.removeEventListener('resize',this.boundVisibility);
    window.removeEventListener('load',this.boundVisibility);
    this.scrollToFormButton?.removeEventListener('click',this.boundScrollToForm);
    this.visibilityObserver?.disconnect();this.formObserver?.disconnect();this.priceObserver?.disconnect();
    if(this.visibilityFrame)cancelAnimationFrame(this.visibilityFrame);
  }
  prepareCompactPurchase() {
    if (!this.inlineButton || this.querySelector('.mh-mobile-purchase')) return;
    const compact=document.createElement('div');compact.className='mh-mobile-purchase';
    const title=document.createElement('div');title.className='mh-mobile-product-title';title.textContent=document.querySelector('.product__title')?.textContent.trim() || '';
    this.compactPrice=document.createElement('div');this.compactPrice.className='mh-mobile-product-price';
    this.compactButton=document.createElement('button');this.compactButton.type='button';this.compactButton.className='button mh-mobile-add';
    this.compactError=document.createElement('div');this.compactError.className='mh-mobile-purchase-error';this.compactError.setAttribute('role','status');
    this.compactButton.addEventListener('click',event => {
      event.preventDefault();event.stopPropagation();
      if(this.inlineButton.disabled || this.inlineButton.classList.contains('disabled'))return;
      this.inlineButton.click();
      this.syncCompactPurchase();
    });
    compact.append(title,this.compactPrice,this.compactButton,this.compactError);this.prepend(compact);
    this.classList.add('mh-mobile-ready');this.syncCompactPurchase();this.syncCompactPrice();
  }
  syncCompactPurchase() {
    if(!this.compactButton || !this.inlineButton)return;
    const busy=this.inlineButton.classList.contains('disabled') || this.inlineButton.getAttribute('aria-busy')==='true';
    this.compactButton.disabled=this.inlineButton.disabled || busy;
    this.compactButton.setAttribute('aria-busy',String(busy));
    const ar=document.documentElement.lang==='ar';
    const label=busy ? (ar?'جارٍ الإضافة…':'Adding…') : this.inlineButton.textContent.trim().replace(/\s+/g,' ');
    if(this.compactButton.textContent!==label)this.compactButton.textContent=label;
    const error=this.inlineForm.querySelector('[data-error-wrapper]');
    const message=error && !error.classList.contains('hidden') ? error.textContent.trim() : '';
    if(this.compactError.textContent!==message)this.compactError.textContent=message;
  }
  syncCompactPrice() {
    if(!this.compactPrice)return;
    const source=document.querySelector('[id^="Product-Price-"] .price');
    if(!source)return;
    const copy=source.cloneNode(true);
    copy.querySelectorAll('.price__notice,.product__notice,.text-navigation-button.sale').forEach(x=>x.remove());
    copy.removeAttribute('id');copy.querySelectorAll('[id]').forEach(x=>x.removeAttribute('id'));
    this.compactPrice.replaceChildren(copy);
  }
  toggleVisibility() {
    if(!this.inlineButton){this.classList.add('is-hidden');return;}
    const rect=this.inlineButton.getBoundingClientRect();
    const headerBottom=Math.max(0,document.querySelector('header')?.getBoundingClientRect().bottom || 0);
    const inlineVisible=rect.top < window.innerHeight-20 && rect.bottom > headerBottom;
    const footer=document.querySelector('footer');
    const footerVisible=footer && footer.getBoundingClientRect().top < window.innerHeight-80;
    this.classList.toggle('is-hidden',inlineVisible || Boolean(footerVisible));
  }
  scrollToForm() {
    const target=document.querySelector('product-form');if(!target)return;
    const offset=document.querySelector('header')?.clientHeight || 0;
    window.scrollTo({top:window.scrollY+target.getBoundingClientRect().top-offset,behavior:'smooth'});
  }
  onChange({name,value}) {
    const matchedSelector=this.productSelectors.filter(selector=>selector.dataset.name===name || selector.name===name).find(selector=>selector.type==='select-one' || selector.value===value);
    if(!matchedSelector)return;
    if(matchedSelector.type==='radio'){matchedSelector.click();return;}
    matchedSelector.value=value;
    Array.from(matchedSelector.options).forEach(option=>option.toggleAttribute('selected',option.value===value));
    matchedSelector.dispatchEvent(this.changeEvent);
  }
}
customElements.define('product-bar',ProductBar);
